import { useAuth } from '@context/auth/base';

export function useShouldShowReferralEarningsIndicator() {
  const { authUser } = useAuth();

  return (
    !!authUser?.lastReferralWithdrawableBalance && authUser.lastReferralWithdrawableBalance !== '0'
  );
}
